import { slice, lastIndexOf } from 'ramda';
import { MediaManagerSDKFile } from './media-manager-sdk';

export const getExtension = (str: string): string => {
  const lastPeriodPosition = lastIndexOf('.', str);
  if (lastIndexOf('/', str) >= lastPeriodPosition) {
    // more like a part of URL, like "com/...long-id-here..."
    return '';
  }

  return lastPeriodPosition === -1 ? '' : str.slice(lastPeriodPosition + 1);
};

export const parseFileName = (fileName: string): { name: string; extension: string } => {
  const extension = getExtension(fileName);
  const name = extension
    ? slice(0, fileName.length - (extension.length ? extension.length + 1 : 0), fileName)
    : fileName;

  return {
    name,
    extension,
  };
};

export const getItemLabel = (item: MediaManagerSDKFile): string =>
  getExtension(item.fileUrl) || parseFileName(item.name).extension;
